import { all, AllEffect, fork, ForkEffect } from 'redux-saga/effects';
import { dismissContentListenerSaga } from './dismiss-content';
import { dismissQuickActionListenerSaga } from './dismiss-quick-action';
import { fatalErrorListenerSaga } from './fatal-error';
import { initializeApplicationListenerSaga } from './initialize-application';
import { setDisableRemoteDesktopStatusListenerSaga } from './set-disable-remote-desktop-status';
import { setWelcomeTourStatusListenerSaga } from './set-welcome-tour-status';
import { syncDisableRemoteDesktopStatusListenerSaga } from './sync-disable-remote-desktop-status';
import { syncDismissedContentListenerSaga } from './sync-dismissed-content';
import { syncWelcomeTourStatusListenerSaga } from './sync-welcome-tour-status';

export function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
    yield all([
        fork(dismissContentListenerSaga),
        fork(dismissQuickActionListenerSaga),
        fork(fatalErrorListenerSaga),
        fork(initializeApplicationListenerSaga),
        fork(syncDismissedContentListenerSaga),
        fork(setWelcomeTourStatusListenerSaga),
        fork(syncWelcomeTourStatusListenerSaga),
        fork(setDisableRemoteDesktopStatusListenerSaga),
        fork(syncDisableRemoteDesktopStatusListenerSaga),
    ]);
}
